export enum CatalogueProjectBomType {
  ebom = 'ebom',
  dbom = 'dbom',
}

export interface CatalogueProject {
  uuid: string;
  name: string;
  dealId: string | null;
  hubspotLink: string | null;
  creatorUuid: string;
  canEdit?: boolean;
}

export interface CatalogueProjectCreate {
  name: string;
  dealId?: string | null;
}

export interface CatalogueProjectUpdate {
  name?: string | null;
  dealId?: string | null;
}

export interface CatalogueProjectBom {
  uuid: string;
  name: string;
  bomType: CatalogueProjectBomType;
  projectUuid: string;
  creatorUuid: string;
  parentUuid?: string | null;
  previousVersionUuid?: string | null;
  canEdit?: boolean;
}

export interface CatalogueProjectBomCreate {
  name: string;
  bomType: CatalogueProjectBomType;
  projectUuid: string;
}

export interface CatalogueProjectBomUpdate {
  name?: string | null;
  bomType?: CatalogueProjectBomType | null;
}

export interface CatalogueProjectBomItem {
  uuid: string;
  bomUuid: string;
  itemUuid: string;
  quantity: number;
  bomLevel?: number;
  parentItemUuid?: string;
  createdAt: string;
}

export interface CatalogueProjectBomItemCreate {
  itemUuid: string;
  quantity: number;
  bomLevel?: number;
  parentItemUuid?: string;
}

export interface CatalogueProjectBomItemUpdate {
  quantity?: number;
  bomLevel?: number;
  parentItemUuid?: string;
}

export enum CatalogueProjectBomDuplicateType {
  default = 'default',
  branch = 'branch',
  version = 'version',
}
